import { BCMSDate, BCMSDefaultModel, DisabledPrompt, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, useRoute, useWorkflow, useModel} from "bcms-react";
import Classes, { Payee, User, UserAccount } from "model";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import UsersTable from "./components/UsersTable";
import { PrimaryButton } from "components/ui";

import "./styles.css";
import "./mobile.css";

/**
 * @function UsersPage
 * @return {React.Component}
 * @exported true
 * @description The main component for UsersPage
 */
export default function UsersPage(props) {
    const model = useModel();
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(model), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };
    const { nextStep, goStep, state: workflow } = useWorkflow() ?? {};

    // Check if a user account was updated in the workflow.
    if(data.userUpdated === true || data.entitlementsUpdated === true) {
        data.selectedUserAccount = UserAccount.initByID(data.selectedUserAccountID);
    }
  
    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
  
        onChange: prop => value => {
          BCMSStateManagerCRUD.init(state)
                .update([ "data", prop ], value)
                .submit(setState);
        },
  
        add: () => {
          const workflowState = BCMSStateManagerCRUD.init(workflow)
          .submit();
          window.scrollTo(0, 0);
          goStep(2, workflowState);
        },
  
        edit: id => () => {
            const loggedInUser = data.loggedInUser;
            const selectedUser = UserAccount.initByID(id)

            window.scrollTo(0, 0);
            
            if (loggedInUser.id !== selectedUser.username) {
                goStep(2, { data: { isEditing: true, selectedUserAccountID: id } })
            } else {
                goStep(1)
            }
        }
    });

    return (
        <PageContainer className="users-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    )
}

export const getDefaultData = (model) => ({
    entitlementsUpdated: false,
    loggedInUser: User.init(model ? model.user : {}),
    userAccounts: UserAccount.initAll(),
    userUpdated: false,
    selectedUserAccountID: undefined,
    selectedUserAccount: undefined
});
  
  export const getDefaultUI = () => ({
    // no ui changes for now
  });

function PageContent(props) {
    const { data, add } = useStateManager();
    let userUpdatedMessage = "";
    const selectedUserAccount = data.selectedUserAccount ?? {}

    if(data.userUpdated === true) {
        userUpdatedMessage = `${ `The user “${ selectedUserAccount.first } ${ selectedUserAccount.last }” has  been updated.` }`
    }

    return (
    <PageContentView>
        <CenterContentContainer>
            <ContentHeaderView text="Users" />
            { data.userUpdated && 
            <InfoBanner text={ userUpdatedMessage } />
            }
            { data.entitlementsUpdated && 
            <InfoBanner text={ `The entitlements for ${ selectedUserAccount.fullName } have been successfully changed.` } />
            }
            <UsersTable />
            <div className="button-container">
                <PrimaryButton text="Add User" onClick={ add } dataPoint="Add_User_Button" />
            </div>
        </CenterContentContainer>
    </PageContentView>
    );
}
